import { useState } from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button, Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import scholarship1 from '../assets/scholarship1.png';
import scholarship2 from '../assets/scholarship2.png';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SchoolIcon from '@mui/icons-material/School';
import StarIcon from '@mui/icons-material/Star';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AutoPopUp from './AutoPopUp';

const ApplyAcholarship = () => {
    const [openPopup, setOpenPopup] = useState(false);

    const handleClosePopup = () => {
        setOpenPopup(false);
    };

    const faqData = [
        {
            question: "How to Apply?",
            answer: "Simply click on the 'Apply for Scholarship' button and fill out the registration form with your details. Our team will contact you with further instructions about the scholarship examination."
        },
        {
            question: "Registration Fees",
            answer: "The registration fee for the Aakash Talent Search Examination is completely free."
        },
        {
            question: "Date of Exam",
            answer: "The scholarship examination is conducted every month. After registration, you will receive the exact date and time for your examination slot via email and SMS."
        },
        {
            question: "When Will I Get the Admission Ticket?",
            answer: "Your admission ticket will be sent to your registered email address or whatsapp number 3-5 days before the examination date. Please check your email regularly and keep the ticket safe."
        },
        {
            question: "When Will the Results Be Announced?",
            answer: "The results will be announced within 10 days after the examination. You will receive your results via email and SMS, along with your scholarship percentage if applicable."
        },
        {
            question: "What if I Don't Get a Rank Within the Top 3?",
            answer: "Even if you don't secure a top 3 rank, you can still receive scholarship benefits based on your performance. We offer multiple scholarship slabs ranging from 25% to 90% fee waiver based on your score."
        },
        // {
        //     question: "Do I Get Any Useful Books if I Come and Write the Exam?",
        //     answer: "Yes! All students who appear for the examination will receive complimentary study materials and practice books worth ₹2000, regardless of their performance."
        // },
        {
            question: "Number of Questions",
            answer: "The examination consists of 60 multiple-choice questions covering Physics, Chemistry, Mathematics/Biology based on your chosen stream. Duration: 2 hours."
        },
        {
            question: "Is There Negative Marking?",
            answer: "No, there is no negative marking for this examination. You can attempt all questions without worrying about losing marks for incorrect answers."
        }
    ];

    const Data = [
        {
            id: '1', color: '#ff6b35', icon: <EmojiEventsIcon sx={{ fontSize: 45, color: 'white' }} />, title: 'Up to 90% Scholarship', desc: "Rewarding academic excellence and dedication with substantial fee waivers",
            points: [
                "✓ Merit-based evaluation",
                "✓ Multiple scholarship slabs",
                "✓ Transparent selection process"
            ]
        },
        {
            id: '2', color: '#66bb6a', icon: <SchoolIcon sx={{ fontSize: 45, color: 'white' }} />, title: 'World-Class Faculty', desc: "Learn from India's best educators with proven teaching methodologies",
            points: [
                "✓ IITian & Doctor faculty",
                "✓ Personalized mentorship",
                "✓ Regular doubt clearing sessions"
            ]
        },
        {
            id: '3', color: '#42a5f5', icon: <StarIcon sx={{ fontSize: 45, color: 'white' }} />, title: '35+ Years Legacy', desc: "Join thousands of successful students who achieved their dreams",
            points: [
                "✓ 2.75 Lakh+ selections",
                "✓ Proven success rate",
                "✓ Pan-India recognition"
            ]
        }
    ]

    return (
        <Box sx={{ bgcolor: '#f8f9fa', py: 8, mt: 10 }}>
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 700,
                            color: '#1a237e',
                            mb: 2,
                            fontSize: { xs: '2rem', md: '3rem' }
                        }}
                    >
                        Aakash Talent Search and Scholarship Test Yelahanka
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            color: '#555',
                            maxWidth: '800px',
                            mx: 'auto',
                            lineHeight: 1.8
                        }}
                    >
                        Unlock your potential with Aakash Yelahanka's prestigious scholarship program.
                        Get up to 90% fee waiver and join India's most trusted coaching institute.
                    </Typography>
                </Box>

                <Grid container spacing={4} sx={{ mb: 6 }}>
                    {[scholarship1, scholarship2].map((item, index) => (
                        <Grid item xs={12} md={6}>
                            <Box
                                component="img"
                                src={item}
                                alt="Aakash Scholarship Program"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    borderRadius: 3,
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>

                <Box sx={{ mb: 6 }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 600,
                            color: '#1a237e',
                            textAlign: 'center',
                            mb: 4
                        }}
                    >
                        Why Apply for Aakash Yelahanka Scholarships?
                    </Typography>
                    <Grid container spacing={4}>
                        {Data.map((item, index) => (
                            <Grid key={index} item xs={12} md={4}>
                                <Card
                                    sx={{
                                        textAlign: 'center',
                                        p: 4,
                                        background: 'rgba(255,255,255,0.95)',
                                        backdropFilter: 'blur(10px)',
                                        border: '2px solid transparent',
                                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                        '&:hover': {
                                            transform: 'translateY(-12px)',
                                            boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                                            border: `2px solid ${item.color}`,
                                            background: 'white'
                                        }
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 80,
                                            height: 80,
                                            borderRadius: '50%',
                                            background: `linear-gradient(135deg, ${item.color} 0%, ${item.color} 100%)`,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mx: 'auto',
                                            mb: 3,
                                            boxShadow: '0 8px 16px rgba(255,107,53,0.3)'
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <CardContent sx={{ p: 0 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: '#1a237e' }}>
                                            {item.title}
                                        </Typography>
                                        <Typography variant="body1" sx={{ color: '#555', lineHeight: 1.8, mb: 2 }}>
                                            {item.desc}
                                        </Typography>
                                        <Box sx={{ bgcolor: '#fff3e0', p: 2, borderRadius: 2, mt: 2 }}>
                                            {item.points.map((item1, index) => (
                                                <Typography key={index} variant="body2" sx={{ fontWeight: 600, color: item.color }}>
                                                    {item1}
                                                </Typography>
                                            ))}
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                {/* Cash Rewards Section */}
                <Box
                    sx={{
                        bgcolor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        background: 'linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%)',
                        borderRadius: 3,
                        p: 5,
                        mb: 6,
                        textAlign: 'center',
                        color: 'white'
                    }}
                >
                    <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
                        Top Achievers Scholarship Benefits
                    </Typography>
                    <Grid container spacing={3}>
                        {[
                            {icon:'🥇', rank:"1st Rank", amount:"₹3,65,000", desc:'Students securing 97% in Boards and ATSST will get a FREE SEAT at NPS Aakash, Yelahanka'},
                            {icon:'🥈', rank:"2nd Rank", amount:"₹1,50,000", desc:'Students securing 95% in Boards and ATSST will get 50% fee concession at NPS and Aakash, Yelahanka'},
                            {icon:'🥉', rank:"3rd Rank", amount:"₹50,000", desc:'Top 50 Students in Aakash Talent search Scholarship Test will get Scholarship for students'},
                        ].map((item, index) => (
                        <Grid item xs={12} md={4}>
                            <Box sx={{ bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 2, p: 3 }}>
                                <Typography variant="h2" sx={{ fontWeight: 700, mb: 1 }}>
                                    {item.icon}
                                </Typography>
                                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                                    {item.rank}
                                </Typography>
                                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                                    {item.amount}
                                </Typography>
                                <Typography variant="body1" sx={{ color: 'white', lineHeight: 1.8, mb: 2 }}>{item.desc}</Typography>
                            </Box>
                        </Grid>
                        ))}
                    </Grid>
                </Box>

                <Box sx={{ mb: 6 }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 600,
                            color: '#1a237e',
                            textAlign: 'center',
                            mb: 4
                        }}
                    >
                        Frequently Asked Questions
                    </Typography>
                    {faqData.map((faq, index) => (
                        <Accordion
                            key={index}
                            sx={{
                                mb: 2,
                                '&:before': { display: 'none' },
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                borderRadius: '8px !important'
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{
                                    '&:hover': { bgcolor: '#f5f5f5' }
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a237e' }}>
                                    {faq.question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Divider sx={{ mb: 2 }} />
                                <Typography variant="body1" sx={{ color: '#555', lineHeight: 1.8 }}>
                                    {faq.answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>

                <Box
                    sx={{
                        bgcolor: '#e3f2fd',
                        borderRadius: 3,
                        p: 5,
                        mb: 6,
                        textAlign: 'center',
                        border: '2px solid #2196f3'
                    }}
                >
                    <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a237e', mb: 3 }}>
                        A Message to All Students
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#555', lineHeight: 1.8, fontStyle: 'italic' }}>
                        "If you are reading this and have applied for the exam, all the best!
                        You are on the right path for your future education, my friend. Good luck!
                        Remember, this is not just an exam – it's an opportunity to transform your dreams into reality.
                        Your dedication and hard work will pave the way for a bright future."
                    </Typography>
                </Box>

                <Box
                    sx={{
                        bgcolor: 'white',
                        borderRadius: 3,
                        p: { xs: 3, md: 5 },
                        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                        textAlign: 'center'
                    }}
                >
                    <Typography variant="h4" sx={{ fontWeight: 600, color: '#1a237e', mb: 2 }}>
                        Ready to Begin Your Journey?
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666', mb: 4 }}>
                        Take the first step towards your dream career. Apply now for the Aakash Talent Search Examination.
                    </Typography>
                    <Button
                        variant="contained"
                        size="large"
                        sx={{
                            bgcolor: '#ff6b35',
                            px: 6,
                            py: 2,
                            fontSize: '1.2rem',
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: '#e55a2b',
                                transform: 'scale(1.05)'
                            },
                            transition: 'all 0.3s ease'
                        }}
                        onClick={() => setOpenPopup(true)}
                    >
                        Apply for Scholarship Now
                    </Button>
                </Box>
            </Container>
            <AutoPopUp isOpen={openPopup} onClose={handleClosePopup} />
        </Box>
    );
};

export default ApplyAcholarship;